import axios from 'axios';
import { PROYECTOS } from './types';

import { setAlert } from './alert';
import { changeLoader } from './loader';
import { listarClientes } from './clientes';

const toUrlEncoded = (data = {}) => {
    const params = new URLSearchParams();
    Object.keys(data).forEach((key) => {
        const value = data[key];
        if (value === undefined) return;
        params.append(key, value === null ? '' : String(value));
    });
    return params.toString();
};

/* Reutiliza /ventas/crear_cliente porque es el único endpoint de creación de clientes que
   devuelve el objeto creado completo (/clientes/crear solo confirma éxito) — no crea nada
   relacionado a ventas, solo inserta el cliente. */
export const crearClienteProyecto = ({ nombre, correo, telefono, rfc }) => async dispatch => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const body = toUrlEncoded({
        nombre: nombre || '',
        correo: correo || '',
        telefono: telefono || '',
        rfc: rfc || ''
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/ventas/crear_cliente`, body, config);
        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo crear el cliente', 'danger'));
            return null;
        }

        dispatch(setAlert(res.data?.msg || 'Cliente creado correctamente', 'success'));

        await dispatch(listarClientes());

        return res.data?.cliente || null;
    } catch (error) {
        await dispatch(changeLoader(false));
        dispatch(setAlert(error?.response?.data?.msg || 'Error al crear cliente', 'danger'));
        return null;
    }
};

export const listarProyectos = (filtros = {}) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        id_cliente: filtros.id_cliente ?? null,
        nombre: filtros.nombre ?? null,
        status: filtros.status ?? null
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/proyectos/listar`, body, config);

        await dispatch({
            type: PROYECTOS.LISTAR,
            payload: res.data?.proyectos || []
        });

        await dispatch(changeLoader(false));
        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: PROYECTOS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al listar proyectos', 'danger'));
        return false;
    }
};

export const filtrarProyectos = (texto = '') => dispatch => {
    dispatch({
        type: PROYECTOS.FILTRAR,
        payload: texto
    });
};

export const setFiltrosProyectos = (filtros = {}) => dispatch => {
    dispatch({
        type: PROYECTOS.SET_FILTROS,
        payload: filtros
    });
};

export const limpiarFiltrosProyectos = () => dispatch => {
    dispatch({ type: PROYECTOS.LIMPIAR_FILTROS });
};

export const limpiarProyectos = () => dispatch => {
    dispatch({ type: PROYECTOS.LIMPIAR });
};

export const crearProyecto = (data = {}) => async (dispatch, getState) => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        id_cliente: data.id_cliente || '',
        nombre: data.nombre || '',
        descripcion: data.descripcion || null,
        direccion: data.direccion || null,
        fecha_inicio_tentativa: data.fecha_inicio_tentativa || null,
        fecha_fin_tentativa: data.fecha_fin_tentativa || null,
        fecha_inicio_real: data.fecha_inicio_real || null,
        fecha_fin_real: data.fecha_fin_real || null
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/proyectos/crear`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo crear el proyecto', 'danger'));
            return false;
        }

        dispatch(setAlert(res.data?.msg || 'Proyecto creado correctamente', 'success'));

        const { filtro_activo, filtros } = getState().proyectos;
        await dispatch(listarProyectos(filtro_activo ? filtros : {}));

        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: PROYECTOS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al crear proyecto', 'danger'));
        return false;
    }
};

export const obtenerDetalleProyecto = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id });

    try {
        await dispatch({ type: PROYECTOS.DETALLE_CARGANDO });
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/proyectos/detalles`, body, config);

        await dispatch({
            type: PROYECTOS.DETALLE,
            payload: res.data?.proyecto || null
        });

        await dispatch(changeLoader(false));
        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: PROYECTOS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al consultar detalles del proyecto', 'danger'));
        return false;
    }
};

export const limpiarDetalleProyecto = () => dispatch => {
    dispatch({ type: PROYECTOS.LIMPIAR_DETALLE });
};

export const obtenerResumenProyecto = (id_proyecto) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id_proyecto });

    try {
        await dispatch({ type: PROYECTOS.RESUMEN_CARGANDO });
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/proyectos/resumen`, body, config);

        await dispatch({
            type: PROYECTOS.RESUMEN,
            payload: {
                resumen: res.data?.resumen || null,
                listados: res.data?.listados || null
            }
        });

        await dispatch(changeLoader(false));
        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: PROYECTOS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al consultar el resumen del proyecto', 'danger'));
        return false;
    }
};

export const limpiarResumenProyecto = () => dispatch => {
    dispatch({ type: PROYECTOS.LIMPIAR_RESUMEN });
};

export const editarProyecto = (data = {}) => async (dispatch, getState) => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({
        id: data.id || '',
        id_cliente: data.id_cliente || '',
        nombre: data.nombre || '',
        descripcion: data.descripcion || null,
        direccion: data.direccion || null,
        fecha_inicio_tentativa: data.fecha_inicio_tentativa || null,
        fecha_fin_tentativa: data.fecha_fin_tentativa || null,
        fecha_inicio_real: data.fecha_inicio_real || null,
        fecha_fin_real: data.fecha_fin_real || null,
        status: data.status ?? null
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/proyectos/editar`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo editar el proyecto', 'danger'));
            return false;
        }

        dispatch(setAlert(res.data?.msg || 'Proyecto editado correctamente', 'success'));

        const { filtro_activo, filtros } = getState().proyectos;
        await dispatch(listarProyectos(filtro_activo ? filtros : {}));
        await dispatch(limpiarDetalleProyecto());

        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: PROYECTOS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al editar proyecto', 'danger'));
        return false;
    }
};

export const cambiarStatusProyecto = (id, status) => async (dispatch, getState) => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id, status });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/proyectos/status`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo cambiar el status del proyecto', 'danger'));
            return false;
        }

        dispatch(setAlert(res.data?.msg || 'Status del proyecto actualizado correctamente', 'success'));

        const { filtro_activo, filtros } = getState().proyectos;
        await dispatch(listarProyectos(filtro_activo ? filtros : {}));

        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: PROYECTOS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al cambiar el status del proyecto', 'danger'));
        return false;
    }
};

export const eliminarProyecto = (id) => async (dispatch, getState) => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    const body = JSON.stringify({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/proyectos/eliminar`, body, config);

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo eliminar el proyecto', 'danger'));
            return false;
        }

        dispatch(setAlert(res.data?.msg || 'Proyecto eliminado correctamente', 'success'));

        const { filtro_activo, filtros } = getState().proyectos;
        await dispatch(listarProyectos(filtro_activo ? filtros : {}));

        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: PROYECTOS.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al eliminar proyecto', 'danger'));
        return false;
    }
};
